import { createSlice } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
  fetchingStructureNote: false,
  inventory: {
    totalAmt: 0,
    accountList: [],
    ccyList: [],
    ccyTotalPresentValueAmt: 0,
    ccyTotalOutStandingAmt: 0,
  },
  documents: [],
};

const slice = createSlice({
  initialState: cloneDeep(initialState),
  name: "structureNote",
  reducers: {
    fetchStructureNoteInfo: (state) => {
      state.fetchingStructureNote = true;
    },
    fetchStructureNoteInfoSuccess: (state, action) => {
      state.fetchingStructureNote = false;
      state.inventory = action.payload.inventory;
      state.documents = action.payload.documents;
    },
    fetchStructureNoteInfoFailure: (state) => {
      return {
        ...state,
        fetchingStructureNote: false,
        inventory: cloneDeep(initialState.inventory),
        documents: [],
      };
    },
  },
});

export const { fetchStructureNoteInfo, fetchStructureNoteInfoSuccess, fetchStructureNoteInfoFailure } = slice.actions;

export default slice;
